<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="@/assets/img/Rings_wh.png"
          alt="Audi logo"
        />
      </b-link>
      <SidebarToggler class="d-none" :defaultOpen="true" />
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <DefaultHeaderDropdown />
        </b-nav-item>
      </b-navbar-nav>
      <AsideToggler class="d-none d-lg-block" />
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="navItems"></SidebarNav>
        <SidebarFooter>
          <LangToggler />
          <AppStatusLink />
        </SidebarFooter>
        <P class="UHD">
            En caso de requerir soporte contáctanos<br/>
            <b>Correo:</b><br/>
            AUDI SJ User Help Desk<br/>
            <a href=" mailto:AUDIUHD@audi.mx ">AUDIUHD@audi.mx</a><br/>
            <b>Teléfono:</b><br/>
            2768903300
            Ext: 3300
        </P>
        <!-- <SidebarMinimizer/> -->
      </AppSidebar>
      <main class="main">
        <!-- <Breadcrumb :list="list"/> -->
        <div class="main-container">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside />
      </AppAside>
    </div>
    <Alert />
    <Spinner :show="isLoading" />
  </div>
</template>

<script>
import Alert from "@/components/alerts/Alert.vue";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb
} from "@coreui/vue";
const DefaultAside = () => import("./DefaultAside");
const DefaultHeaderDropdown = () => import("./DefaultHeaderDropdown");
const LangToggler = () => import("@/components/LangToggler");
const AppStatusLink = () => import("@/components/AppStatusLink");

export default {
  name: "DefaultContainer",
  components: {
    Alert,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    LangToggler,
    AppStatusLink
  },
  data() {
    return {};
  },
  computed: {
    isLoading: function() {
      return this.$store.getters["global/isLoading"];
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        route => route.name || route.meta.label
      );
    },
    menuItems: function() {
      return [
        {
          pathName: "Dashboard",
          name: this.$t("sideBar.dashboard"),
          url: "/dashboard"
        },
        {
          pathName: "Info",
          name: this.$t("sideBar.general_info"),
          url: "/info"
        },
        {
          pathName: "news",
          name: this.$t("sideBar.news"),
          url: "/news"
        },
        {
           pathName: "Compensations",
           name: this.$t("sideBar.compensation.title"),
           url: "/compensations",
	      },
        {
          pathName: "Map",
          name: this.$t("sideBar.map.map"),
          url: "/map",
          children: [
            {
              pathName: "Benefits",
              name: this.$t("sideBar.map.benefit"),
              url: "/map/benefits"
            },
            {
              pathName: "Interactive Map",
              name: this.$t("sideBar.map.interactiveMap"),
              url: "/map/interactiveMap/"
            }
          ]
        },
        {
          pathName: "Blog",
          name: this.$t("sideBar.blog"),
          url: "/blog"
        },
        {
          pathName: "Strategy",
          name: this.$t("sideBar.strategy.title"),
          url: "/strategy"
        },
        {
          pathName: "Surveys",
          name: this.$t("sideBar.survey"),
          url: "/survey",
          children: [
            {
              pathName: "Surveys",
              name: this.$t("surveys.dropdownMenuItem1"),
              url: "/survey"
            },
            {
              pathName: "Survey Terms",
              name: this.$t("surveys.dropdownMenuItem2"),
              url: "/survey/terms"
            }
          ]
        },
        {
          pathName: "Diagnostic",
          name: this.$t("sideBar.diagnostic.title"),
          url: "/diagnostic",
          children: [
            {
              pathName: "Diagnostic",
              name: this.$t("sideBar.diagnostic.survey"),
              url: "/diagnostic"
            },
            {
              pathName: "DaignosticCategory",
              name: this.$t("sideBar.diagnostic.category"),
              url: "/diagnostic/category"
            },
            {
              pathName: "ListTemplates",
              name: this.$t("sideBar.diagnostic.templates"),
              url: "/diagnostic/templates"
            }
          ]
        },
        {
          pathName: "Events",
          name: this.$t("sideBar.events.events"),
          url: "/events"
        },
        {
          pathName: "Coupons",
          name: this.$t("sideBar.coupons"),
          url: "/coupons/faq"
        },
        {
          pathName: "T4i",
          name: this.$t("sideBar.t4i"),
          url: "/t4i"
        },
        //qr
        {
          pathName: "Burden File",
          name: this.$t("sideBar.burden.title"),
          url: "/burdenFile",
        },
        //qr
        {
          pathName: "IntegrityCompliance",
          name: this.$t("sideBar.integrityCompliance"),
          url: "/integrityCompliance"
        },
        {
          pathName: "menu",
          name: this.$t("sideBar.menu"),
          url: "/menu"
        },
        {
          pathName: "Conduct",
          name: this.$t("sideBar.conduct"),
          url: "/conduct"
        },
        {
          pathName: "Calendar",
          name: this.$t("sideBar.calendar"),
          url: "/calendar"
        },
        {
          pathName: "Report Photos",
          name: this.$t("sideBar.reportPhotos"),
          url: "/reportPhotos"
        },
        {
          pathName: "KeyUser",
          name: this.$t("sideBar.keyUser"),
          url: "/keyuser"
        },
        {
          pathName: "Ecadia",
          name: this.$t("sideBar.ecadia"),
          url: "/ecadia"
        },
        {
          pathName: "RH Assessor",
          name: this.$t("sideBar.rhAssessor"),
          url: "/rhAssessor"
        },
        {
          pathName: "QR Access",
          name: this.$t("sideBar.qrAccess.qr"),
          url: "/qraccess",
          children: [
       {
              pathName: "Trips",
              name: this.$t("sideBar.qrAccess.trips"),
              url: "/qraccess/trips"
            },
            {
              pathName: "Drivers",
              name: this.$t("sideBar.qrAccess.drivers"),
              url: "/qraccess/drivers"
            },
          {
              pathName: "Bus Routes",
              name: this.$t("sideBar.qrAccess.busRoutes"),
              url: "/qraccess/busRoutes"
            },
            {
              pathName: "Reports",
              name: this.$t("sideBar.qrAccess.reports"),
              url: "/qraccess/reports"
            }
          ]
        },
        {
          pathName: "Files and Links",
          name: this.$t("sideBar.uploadsAndLinks.title"),
          url: "/filesAndLinks",
          children: [
            {
              pathName: "S3 Uploads",
              name: this.$t("sideBar.uploadsAndLinks.uploadFiles"),
              url: "/filesAndLinks/s3Uploads"
            }
          ]
        },
        {
          pathName: "Mobility On Demand",
          name: this.$t("sideBar.mobilityOnDemand.title"),
          url: "/mobilityOnDemand",
          children: [
            {
              pathName: "Drivers Report",
              name: this.$t("sideBar.mobilityOnDemand.driversReport"),
              url: "/mobilityOnDemand/driversReport"
            },
            {
              /* OK*/
              pathName: "Rides Mobility",
              name: this.$t("sideBar.mobilityOnDemand.Rides"),
              url: "/mobilityOnDemand/ridesMobility"
            }
            ,
            {
              pathName: "Drivers Mobillity",
              name: this.$t("sideBar.mobilityOnDemand.drivers"),
              url: "/mobilityOnDemand/drivers"
            }
            ,
            {
              pathName: "Vehicles Mobillity",
              name: this.$t("sideBar.mobilityOnDemand.vehicles"),
              url: "/mobilityOnDemand/vehicles"
            }
          ]
        },
        /*Booking Transport*/
        {
          pathName: "Booking Transport",
          name: this.$t("sideBar.bookingTransport.title"),
          url: "/bookingTransport",
          children: [
            // {
            //   pathName: "Platform Booking",
            //   name: this.$t("sideBar.bookingTransport.platform"),
            //   url: "/bookingTransport/platformBooking"
            // },
             {
              pathName: "Routes Booking",
              name: this.$t("sideBar.bookingTransport.routes"),
              url: "/bookingTransport/RoutesBooking"
            },
             {
              pathName: "Stops Booking",
              name: this.$t("sideBar.bookingTransport.stops"),
              url: "/bookingTransport/StopsBooking"
            },
             {
              pathName: "Planning Booking",
              name: this.$t("sideBar.bookingTransport.planning"),
              url: "/bookingTransport/PlanningBooking"
            },
            {
              pathName: "Extraordinary Booking",
              name: this.$t("sideBar.bookingTransport.extraordinary"),
              url: "/bookingTransport/ExtraordinaryBooking"
            },
            {
              pathName: "Schedule Booking",
              name: this.$t("sideBar.bookingTransport.schedule"),
              url: "/bookingTransport/ScheduleBooking"
            },
            {
              pathName: "Cancellation Booking",
              name: this.$t("sideBar.bookingTransport.cancellation"),
              url: "/bookingTransport/CancellationBooking"
            },
            {
              pathName: "Reserve Booking",
              name: "Reservar viaje",
              url: "/bookingTransport/ReserveBooking"
            },
            {
              pathName: "Drivers",
              name: this.$t("sideBar.qrAccess.drivers"),
              url: "/qraccess/drivers"
            },
            {
              pathName: "Platforms",
              name: this.$t("sideBar.map.platforms"),
              url: "/map/transport/platforms"
            },
            {
              pathName: "Schedules",
              name: this.$t("sideBar.map.schedules"),
              url: "/map/transport/schedules"
            },
            {
              pathName: "Guidelines",
              name: this.$t("sideBar.map.guidelines"),
              url: "/map/transport/guidelines"
            },
            {
              pathName: "FAQ",
              name: this.$t("sideBar.map.faq"),
              url: "/map/transport/faq"
            }
          ]
        },
        /* Mobile Stiva*/
        {
          pathName: "Mobile Stiva",
          name: this.$t("sideBar.mobileStiva.title"),
          url: "/mobileStiva",
          children: [
            {
              pathName: "History File",
              name: this.$t("sideBar.mobileStiva.historyFile"),
              url: "/mobileStiva/historyFile"
            }
          ]
        },
        /*Open To Move*/
        {
          pathName: "Open Move",
          name: this.$t("sideBar.openToMove.title"),
          url: "/openMove",
          children: [
            {
              pathName: "Application Open",
              name: this.$t("sideBar.openToMove.openToMove"),
              url: "/openMove/ApplicationOpen"
            },
            {
              pathName: "Detail Open",
              name: this.$t("sideBar.openToMove.detailOpen"),
              url: "/openMove/DetailOpen"
            }
        ]
        },
        {
          pathName: "Ideas",
          name: this.$t("sideBar.ideas.ideas"),
          url: "/ideas",
          children: [
            {
              pathName: "Ideas General",
              name: this.$t("sideBar.ideas.general"),
              url: "/ideas/general"
            },
            {
              pathName: "Ideas Stats",
              name: this.$t("sideBar.ideas.stats"),
              url: "/ideas/stats"
            },
            {
              pathName: "Ideas Top",
              name: this.$t("sideBar.ideas.top"),
              url: "/ideas/top"
            },
            {
              pathName: "Ideas Campaign",
              name: this.$t("sideBar.ideas.campaign"),
              url: "/ideas/campaign"
            },
            {
              pathName: "Ideas Points",
              name: this.$t("sideBar.ideas.points.points"),
              url: "/ideas/points",
              children: [
                {
                  pathName: "Points Score",
                  name: this.$t("sideBar.ideas.points.score"),
                  url: "/ideas/points/score"
                },
                {
                  pathName: "Points Redeem",
                  name: this.$t("sideBar.ideas.points.redeem"),
                  url: "/ideas/points/redeem"
                }
              ]
            },
            {
              pathName: "Ideas Rewards",
              name: this.$t("sideBar.ideas.rewards"),
              url: "/ideas/rewards"
            }
          ]
        },
        {
          pathName: "Metrics",
          name: this.$t("sideBar.metrics.metrics"),
          url: "/metrics",
          children: [
            {
              pathName: "Collaborators Metric",
              name: this.$t("sideBar.metrics.collaborators"),
              url: "/metrics/collaborators"
            }
          ]
        },
        {
          pathName: "Lost Items",
          name: this.$t("sideBar.lostItems.lostItems"),
          url: "/lostItems",
          children: [
            {
              pathName: "Lost Items",
              name: this.$t("sideBar.lostItems.lostItems"),
              url: "/lostItems"
            },
            {
              pathName: "Lost Items Instructions",
              name: this.$t("sideBar.lostItems.instructions"),
              url: "/lostItems/instructions"
            }
          ]
        },
        {
          pathName: "Groups",
          name: this.$t("sideBar.groups"),
          url: "/groups"
        },
        {
          pathName: "Service Line",
          name: this.$t("sideBar.serviceLine"),
          url: "/serviceline"
        },
        {
          pathName: "Screenshots",
          name: this.$t("sideBar.screenshots"),
          url: "/screenshots"
        },
        {
          pathName: "Care",
          name: this.$t("sideBar.care"),
          url: "/care"
        },
        {
          pathName: "Synctool",
          name: this.$t("sideBar.synctool"),
          url: "/synctool"
        },
        {
          pathName: "Legal",
          name: this.$t("sideBar.legal.legal"),
          url: "/legal",
          children: [
            {
              pathName: "Legal Terms",
              name: this.$t("sideBar.legal.terms"),
              url: "/legal/terms"
            },
            {
              pathName: "Legal Privacy",
              name: this.$t("sideBar.legal.privacy"),
              url: "/legal/privacy"
            }
          ]
        },
        {
          pathName: "Synchronization",
          name: "Permisos de usuario",
          url: "/synchronization",
        },
        {
          pathName: "Apps",
          name: this.$t("sideBar.apps"),
          url: "/apps"
        },
        {
          pathName: "User",
          name: this.$t("sideBar.users.users"),
          url: "/user",
          children: [
            {
              pathName: "User Manage",
              name: this.$t("sideBar.users.admin"),
              url: "/user/manage"
            },
            {
              pathName: "Volkswagen SP",
              name: this.$t("sideBar.users.volkswagenSP"),
              url: "/user/volkswagenSP"
            },
            {
              pathName: "UTP Students",
              name: this.$t("sideBar.users.utpStudents"),
              url: "/user/utpStudents"
            },
            {
              pathName: "Practitioners",
              name: this.$t("sideBar.users.practitioners"),
              url: "/user/practitioners"
            },
            {
              pathName: "Extern",
              name: this.$t("sideBar.users.extern"),
              url: "/user/extern"
            },
            {
              pathName: "User Chart",
              name: this.$t("sideBar.users.chart"),
              url: "/user/chart"
            }
          ]
        }
      ];
    },
    navItems: function() {
      const pathList = this.$store.getters["session/accessList"].map(
        path => path.name
      );
      return this.menuItems.filter(item => pathList.includes(item.pathName));
    }
  }
};
</script>

<style lang="scss" scoped>
.app {
  position: relative;
}
.main-container {
  margin: 40px 50px;
}
.UHD {
  color: $wg_1;
  font-size: 12px;
  margin: 0;
}
</style>
